import React, { Suspense } from 'react';
import {BrowserRouter} from "react-router-dom";
import {AppRoutes} from "./providers";
import {MantineProvider} from '@mantine/core';
import {Notifications} from "@mantine/notifications";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import "yet-another-react-lightbox/styles.css";
import '@mantine/notifications/styles.css';
import '@mantine/carousel/styles.css';
import '@mantine/core/styles.css';
import { FormProvider, useForm } from './providers';

export const App = () => {

    const form = useForm({
        mode: 'uncontrolled',
        initialValues: {
            firstname: '',
            lastname: '',
            middlename: '',
            company: '',
            unit: '',
            position: '',
            phone: '',
            email: '',
            title: '',
            flag: false,
            check: false,
            event: '',
        },
        validate: {
            firstname: (value) => (!value ? 'Обязательное поле' : null),
            lastname: (value) => (!value ? 'Обязательное поле' : null),
            company: (value) => (!value ? 'Обязательное поле' : null),
            unit: (value) => (!value ? 'Обязательное поле' : null),
            position: (value) => (!value ? 'Обязательное поле' : null),
            event: (value) => (!value ? 'Обязательное поле' : null),
            email: (value) => {
                if (!value) return 'Обязательное поле';

                const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

                return !emailRegex.test(value) ? 'Некорректный email' : null;
            },
            phone: (value) => {
                const digits = value.replace(/\D/g, '');

                if (!digits) return 'Обязательное поле';

                if (digits.length < 11) {
                    return 'Заполните номер телефона';
                }

                return null;
            },
            check: (value) => (!value ? 'Необходимо согласие на обработку данных' : null),
        },
    });

  return (
    <MantineProvider>
      <Notifications />
      <BrowserRouter>
        <Suspense fallback={<></>}>
            <FormProvider form={form}>
                <AppRoutes />
            </FormProvider>
        </Suspense>
      </BrowserRouter>
    </MantineProvider>
  );
}